import { api } from './client';

export async function getProgress(childId) {
  return api.get(`/progress/${childId}`);
}
